import React from 'react';
import { Youtube, Globe, Users, Film } from 'lucide-react';

const AboutSection = () => {
  const highlights = [
    {
      icon: Youtube,
      title: "Enterprise MCN",
      description: "Among the 15 registered Enterprise MCN's on YouTube from India"
    },
    {
      icon: Globe,
      title: "Global Reach",
      description: "Operating in 160+ countries with content in 100+ languages"
    },
    {
      icon: Users,
      title: "250+ Influencers",
      description: "Exclusively working with influencers across all genres"
    },
    {
      icon: Film,
      title: "400+ Web Series",
      description: "Produced in 15 languages over the past 40 months"
    }
  ];

  return (
    <section id="about" className="bg-white relative" style={{ paddingTop: '16px', paddingBottom: '24px', marginTop: '-1px', borderTop: 'none', zIndex: 10 }}>
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Highlights Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 mb-6 md:mb-12">
            {highlights.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className="text-center p-6 rounded-xl hover:shadow-lg transition-shadow bg-gradient-to-b from-gray-50 to-white border border-gray-100"
                  data-testid={`highlight-${index}`}
                >
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-[#0077cc] to-[#00c6d7] rounded-full mb-4">
                    <Icon className="text-white" size={24} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600 text-sm">{item.description}</p>
                </div>
              );
            })}
          </div>

          {/* Story & Network - Separate Cards */}
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            {/* Our Story Card */}
            <div className="bg-gradient-to-br from-[#0077cc]/5 to-[#00c6d7]/5 rounded-2xl p-8 border border-[#0077cc]/10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Our Story
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Infinitum, founded in 2017, apart from being among the 15 registered Enterprise MCN's on YouTube from India is also the biggest entertainment creator in South India. It has been instrumental in creating a paradigm shift in the quality of content uploaded on YouTube in India.
              </p>
              <p className="text-gray-700 leading-relaxed">
                It has also been a pioneer in producing high quality entertainment content and has produced nearly 400 web series in 15 languages over the past 40 months including the top 5 "most watched" web series ever in Telugu on the platform.
              </p>
            </div>

            {/* Our Network Card */}
            <div className="bg-gradient-to-br from-[#00c6d7]/5 to-[#0077cc]/5 rounded-2xl p-8 border border-[#00c6d7]/10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Our Network
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Infinitum also exclusively works with more than 250 influencers across all genres and helps them create content on YouTube and Instagram through innovative and transformative strategies.
              </p>
              <p className="text-gray-700 leading-relaxed">
                We are among the largest content partners to YouTube in Southeast Asia covering diverse genres like learning, entertainment, comedy, sports, beauty, fashion, lifestyle and food.
              </p>
            </div>
          </div>
          
          {/* Achievement Highlight */}
          <div className="p-6 bg-gradient-to-r from-[#0077cc]/5 to-[#00c6d7]/5 rounded-2xl border border-[#0077cc]/10">
            <p className="text-gray-700 leading-relaxed text-center text-sm md:text-base">
              The combined network owns and operates more than <span className="font-bold text-[#0077cc]">550 channels</span> out of which <span className="font-bold text-[#0077cc]">60+ channels</span> have above a million subscribers and around <span className="font-bold text-[#0077cc]">150+ channels</span> have more than 100,000 subscribers making us one of the most awarded "Owned and Operated" networks on YouTube.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
